module.exports = __webpack_public_path__ + "img/3-icono-pendientes.7f380862.svg";